"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Box_1 = require("../Box");
var ResizerBox = styled_components_1.default(Box_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  cursor: col-resize;\n"], ["\n  cursor: col-resize;\n"])));
var Resizer = /** @class */ (function (_super) {
    tslib_1.__extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.ref = React.createRef();
        _this.onMouseDown = function (event) {
            if (_this.ref.current) {
                var element = _this.ref.current;
                var rect = element.getBoundingClientRect();
                _this.setState({ start: event.clientX, width: rect.width }, function () {
                    document.addEventListener('mousemove', _this.onMouseMove);
                    document.addEventListener('mouseup', _this.onMouseUp);
                });
            }
        };
        _this.onMouseMove = function (event) {
            var _a = _this.props, onResize = _a.onResize, property = _a.property;
            var _b = _this.state, start = _b.start, width = _b.width;
            // We determined 12 empirically as being wide enough to hit but
            // not too wide to cause false hits.
            var nextWidth = Math.max(12, width + (event.clientX - start));
            onResize(property)(nextWidth);
        };
        _this.onMouseUp = function () {
            document.removeEventListener('mouseup', _this.onMouseUp);
            document.removeEventListener('mousemove', _this.onMouseMove);
            _this.setState({ start: undefined, width: undefined });
        };
        return _this;
    }
    Resizer.prototype.render = function () {
        var _a = this.props, children = _a.children, onResize = _a.onResize, theme = _a.theme;
        var start = this.state.start;
        if (onResize) {
            return (React.createElement(Box_1.Box, { ref: this.ref, direction: "row", fill: true },
                children,
                React.createElement(ResizerBox, tslib_1.__assign({ flex: false }, theme.dataTable.resize, { onMouseDown: this.onMouseDown, onMouseMove: start ? this.onMouseMove : undefined, onMouseUp: start ? this.onMouseUp : undefined }))));
        }
        return children;
    };
    return Resizer;
}(React.Component));
var ResizerWrapper = recompose_1.compose(styled_components_1.withTheme)(Resizer);
exports.Resizer = ResizerWrapper;
var templateObject_1;
//# sourceMappingURL=Resizer.js.map